import { computed, toValue } from 'vue';
import { useAccount } from './useAccount';
import { useMapGetter } from './store';

export function useAccountResource(key, inboxId) {
  const { currentAccount } = useAccount();
  return computed(() => {
    const controls = currentAccount.value.resource_controls;
    if (controls?.enabled?.[key] !== true) return false;
    if (inboxId === undefined) return true;
    return controls.inbox_ids?.[key]?.includes(toValue(inboxId)) === true;
  });
}

export function useMasterProfile() {
  const membership = useMapGetter('getCurrentAccount');
  return computed(() =>
    Boolean(membership.value.permissions?.includes('master'))
  );
}
